import Vue from 'vue';
import Vuex from 'vuex';
import Bugsnag from '@bugsnag/js';

import { eventBus } from './main';

var Promise = require('es6-promise').Promise;
require('es6-promise').polyfill();
var debounce = require('debounce');


Vue.use(Vuex);
var proto_messages = require("./proto/ManualScoreboard_pb.js");
var coordinator_messages = require("./proto/Messages_pb.js");

var wsR = require('./assets/js/reconnecting-websocket.min.js');

function getQueryStringValue (key) {  
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
}

var connections = {graphics : '', coordinator: ''};
var urlVenueId = getQueryStringValue("venueId");


// this is the beginning of the old-format GeneralMessage with a nested VersionMessage
const oldFormatVersionMessageStartBytes = createOldFormatVersionMessageStartBytes();

function createGeneralMessageWithEmptyVersionMessage()
{
    var generalMessage = new coordinator_messages.GeneralMessage();
    var messageType = new coordinator_messages.MessageType();
    messageType.setValue(coordinator_messages.MessageType.Type.VERSION);
    generalMessage.setMessagetype(messageType);

    var versionMessage = new coordinator_messages.VersionMessage();
    generalMessage.setVersionmessage(versionMessage);

    return generalMessage;
}

function createOldFormatVersionMessageStartBytes()
{
    var genMsg = createGeneralMessageWithEmptyVersionMessage();
    var genMsgData = genMsg.serializeBinary();
    const startBytesLength = 5;   // we check the first 5 bytes
    var startBytesArray = new Uint8Array(startBytesLength);
    var realLength = Math.min(startBytesLength, genMsgData.length);
    for (var i = 0; i < realLength; ++i)
    {
        startBytesArray[i] = genMsgData[i];
    }

    return startBytesArray;
}

function isOldFormatMessage(message)
{
    var startBytesLength = oldFormatVersionMessageStartBytes.length;
    var msgView = new Uint8Array(message);
    if (msgView.length < startBytesLength)
    {
        return false;
    }
    
    // check if the message starts with 'oldFormatVersionMessageStartBytes'
    var i = 0;
    while ((i < startBytesLength) && (msgView[i] == oldFormatVersionMessageStartBytes[i]))
    {
        ++i;
    }
    
    return (i >= startBytesLength);
}

function createWs(url, app)
{
    var socket = new wsR(url, null, {debug: false}); // , constructor: html5WebSocket
    socket.onopen = function () {
        store.dispatch('wsConnectionChanged', true);
        if(app == 'graphics')
        {
            setTimeout(function() {
                store.dispatch("sendHello", false);
            }, 1000);
        }
    };

    socket.onmessage = function (evt) {
        var receivedMsg = evt.data;
        if (receivedMsg instanceof Blob)
        {
            if(app == 'graphics')
            {
                eventBus.$emit('liveIndication', true);
            }
            
            var reader = new FileReader();
            reader.addEventListener("loadend", function () {
                var incomingData = reader.result;
                if(app == 'graphics')
                {
                    try
                    {
                        var t = proto_messages.GeneralMessage.deserializeBinary(incomingData);
                        store.dispatch('wsGraphicsMessageArrived', t);
                    }
                    catch(e)
                    {
                        console.log("Error: " + e);
                    }
                }
                else
                {
                    try
                    {
                        if (isOldFormatMessage(incomingData))
                        {
                            console.log("Received old-format message");
                            var genMsg = coordinator_messages.GeneralMessage.deserializeBinary(incomingData);
                            if (genMsg.getMessagetype() == coordinator_messages.MessageType.Type.VERSION)
                            {
                                //store.dispatch('handleVersionMessage', genMsg);
                            }
                        }
                        else
                        {
                            store.dispatch('wsCoordinatorMessageArrived', incomingData);
                        }
                    }
                    catch(e)        
                    {
                        console.error("Caught exception: " + e.toString());
                    }
                }
            });
            reader.readAsArrayBuffer(receivedMsg);    
        }
        else
        {
            var pingMessage = JSON.parse(receivedMsg);
            if (pingMessage.type != undefined && pingMessage.type == "ping")
            {
                console.log("Received ping");
                store.dispatch('wsGraphicsMessageArrived', "ping");
            }
        }
    };

    socket.onclose = function (evt) {
        console.log("Disconnected!");
        if(app == 'graphics')
        {
            eventBus.$emit('liveIndication', false);
        }
        store.dispatch('wsConnectionChanged', false);
    };
    
    socket.onerror = function (evt) {
        console.log("Error: ");
        console.log(evt);
    };

    return socket;
}

function createOverrideToWebMessage()
{
    var gm = new proto_messages.GeneralMessage();
    gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_OVERRIDE_SCOREBOARD);
    gm.setScoreboardoverridemessage(new proto_messages.ScoreboardOverride());           
    gm.getScoreboardoverridemessage().setScoreboardprovider(proto_messages.ScoreboardProviders.WEB);
    gm.getScoreboardoverridemessage().setForceoverride(true);
    return gm;
}

var wsProxyIP = getQueryStringValue('ws');
var wssProxyIP = getQueryStringValue('wss');
var showCGLayers = getQueryStringValue('showlayers');
var graphicsToken = getQueryStringValue("token");
var coordinatorToken = getQueryStringValue("ctoken");
var hasCoordinatorUrl = false;

if (wsProxyIP == "")
{
    if (location.host.indexOf(":") != -1)
    {
        wsProxyIP = location.host.split(':')[0];
    }
    else
    {
        wsProxyIP = location.host;    
    }
}

for (var app in connections) {
    var urlToken = app == 'graphics' ? graphicsToken : coordinatorToken;
    var wsProxyPort = getQueryStringValue('port');

    if(urlToken != "")
    {
        if (wsProxyPort == "")
        {
            wsProxyPort = app == 'graphics' ? 9009 : 9001;
        }
    
        var urlPrefix = "ws";
        if (location.protocol == 'https:' || wssProxyIP != "")
        {
            urlPrefix = "wss";
        }
    
        var token = "?token=" + urlToken;
    
        if (wssProxyIP != "")
        {
            wsProxyIP = wssProxyIP;
        }
            
        var socketUrl = urlPrefix + '://' + wsProxyIP + ':' + wsProxyPort + token;
    
        console.log("Connecting to: " + socketUrl);
        connections[app] = createWs(socketUrl, app)

        if(app == 'coordinator')
        {
            hasCoordinatorUrl = true;
        }
    }
}

var calcTime = function(min, seconds){
    if (seconds < 10)
        seconds = "0" + seconds;
            
    if (min < 10)
        min = "0" +  min;

    return min + ":" + seconds;
};

var notifyDataSent = function(func, user, data){
    Bugsnag.notify(user + "_" + func, function (event) {
        event.severity = "info";
        event.addMetadata('Data', {
          venueId: urlVenueId,
          payload: data,
          user: user
        })
      })
};

export const store = new Vuex.Store({
    state: {
        wsSocket: connections['graphics'],
        wsCoordinator: connections['coordinator'],
        connectedToWSProxy: false,
        clockSeconds: 0,
        clockMinutes: 0,
        homeScore: 0,
        homeName: "",
        awayScore: 0,
        awayName: "",
        clockStarted: false,
        firstConnection: true,
        singularURL: "",
        suspendTeamNamesUpdate: false,
        currentSportsType: "football",
        controllerSwitches: [],
        clockDirection: proto_messages.ClockDirection.CLOCK_DIRECTION_UP,
        selectedPeriod: 1,
        periodLength: 0,
        extraTime: 0,
        overTime: 0,
        showLayers: showCGLayers,
        showPresets: hasCoordinatorUrl,
        lastLayerStateClicked: Date.now(),
        scoreProviderTypes: [
            { text: "WEB",          value: proto_messages.ScoreboardProviders.WEB},
            { text: "OCR",          value: proto_messages.ScoreboardProviders.OCR},
            { text: "SPORTZCAST",   value: proto_messages.ScoreboardProviders.SPORTZCAST}
        ],
        scoreboardProviderType: {},
        needsOverride: false,
    },
    actions: {
        sendHello(context, payload)
        {
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_HELLO);
            gm.setHellomessage(new proto_messages.ScoreboardHello());
            gm.getHellomessage().setOverride(payload);
            console.log("Sending hello"); 
            context.commit({
                type: 'sendData', 
                data: gm
            });            
        },
        startClock(context, payload) {
            console.log(payload.Minutes + ":" + payload.Seconds)
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_CLOCK);
            gm.setClockmessage(new proto_messages.ClockMessage());
            gm.getClockmessage().setAction(proto_messages.ClockActionType.CLOCK_ACTION_START);
            gm.getClockmessage().setDirection(context.state.clockDirection);
            var time = calcTime(payload.Minutes, payload.Seconds);

            gm.getClockmessage().setTime(time);
                        gm.getClockmessage().setDirection(context.state.clockDirection);

            console.log("Sending start (" + time + ")");
            context.commit({
                type: 'sendData', 
                data: gm
            });            
            
        },
        setClock(context, payload) {
            console.log(payload.Minutes + ":" + payload.Seconds)
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_CLOCK);
            gm.setClockmessage(new proto_messages.ClockMessage());
            gm.getClockmessage().setAction(proto_messages.ClockActionType.CLOCK_ACTION_SET);
            gm.getClockmessage().setDirection(context.state.clockDirection);
            var time = calcTime(payload.Minutes, payload.Seconds);
            
            gm.getClockmessage().setTime(time);
                        gm.getClockmessage().setDirection(context.state.clockDirection);

            console.log("Sending Set (" + time + ")");
            context.commit({
                type: 'sendData', 
                data: gm
            });            
            
        },
        stopClock(context) {
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_CLOCK);
            gm.setClockmessage(new proto_messages.ClockMessage());           
            gm.getClockmessage().setAction(proto_messages.ClockActionType.CLOCK_ACTION_STOP);
            gm.getClockmessage().setDirection(context.state.clockDirection);


            console.log("Sending stop");           
            context.commit({
                type: 'sendData', 
                data: gm
            });            
            
        },
        sendPeriodLength(context, lengthDiff) {
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_EVENT_INFO);
            gm.setEventinfomessage(new proto_messages.EventInfo());           
            gm.getEventinfomessage().setPeriodlength(context.state.periodLength + parseInt(lengthDiff));
            console.log("Sending period length: " + parseInt(context.state.periodLength + parseInt(lengthDiff)));           
            context.commit({
                type: 'sendData', 
                data: gm
            });            
        },
        wsConnectionChanged(context, isConnected) {
            context.commit('setConnectedToWSProxy', isConnected);
        },
        wsCoordinatorMessageArrived(context, message) {
            try
            {
                // this must be a CoordinatorMessage
                var coordinatorMsg = coordinator_messages.CoordinatorMessage.deserializeBinary(message);
                var msgTypeStr = coordinatorMsg.getMessagetypestr();
                var msgContent = coordinatorMsg.getMessagecontent();
                switch (msgTypeStr)
                {
                    case "ProtoMessages.GeneralMessage":
                        //console.log(msgTypeStr);
                        //context.dispatch('handleGeneralMessage', msgContent);
                        break;
                    default:
                        console.log('Unsupported incoming message: ' + msgTypeStr + ' ' + msgContent);
                        break;
                }
            }
            catch (e)
            {
                console.error("Failed to deserialize a CoordinatorMessage, error: " + e.toString());
            }
        },
        wsGraphicsMessageArrived(context, message) {
            if (message == "ping")
            {
                context.commit('sendPong');
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_CLOCK)
            {
                var sTime = message.getClockmessage().getTime();
                console.log("##########################" + sTime);

                var timeParts = sTime.split(":");
                context.commit('setSeconds', parseInt(timeParts[1]));
                context.commit('setMinutes', parseInt(timeParts[0]));
                console.log("clock state: " + message.getClockmessage().getClockstate());
                context.commit('setClockStarted', message.getClockmessage().getClockstate() == proto_messages.ClockStates.CLOCK_STATE_STARTED);
                context.commit('setClockDirection', message.getClockmessage().getDirection());

                
                // context.commit('setSeconds', message.getClockmessage().getSeconds());
                // context.commit('setMinutes', message.getClockmessage().getMinutes());
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_SINGULAR)
            {
                context.commit('setSingularURL', message.getSingularmessage().getUrl());
				console.log(message.getSingularmessage().getUrl());
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_UPDATE)
            {
                context.commit('updateMessageReceived', message.getUpdatemessage());

                // This can be used for Live indicator
                console.log("Game state: " + message.getStatemessage());
                //context.commit('setClockStarted', message.getStatemessage() == proto_messages.GameStates.GAME_STATE_STARTED);
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_STATUS)
            {
                // This can be used for Live indicator
                // Moved to update message
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_TEAMNAMES)
            {
                var homeTeamName = message.getTeamnamesmessage().getHometeamname();
                context.commit('setHomeName', homeTeamName);

                var awayTeamName = message.getTeamnamesmessage().getAwayteamname();
                context.commit('setAwayName', awayTeamName);
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_EVENT_INFO)
            {
                var sportsType = message.getEventinfomessage().getSporttype();
                var periodLength = message.getEventinfomessage().getPeriodlength();
                var extraTime = message.getEventinfomessage().getExtratime();
                console.log("sportsType: " + sportsType);
                console.log("periodLength: " + periodLength);
                console.log("extraTime: " + extraTime);

                context.commit('setSportsType', sportsType);
                context.commit('setPeriodLength', periodLength);
                context.commit('setExtraTime', extraTime);
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_GRAPHICS_LAYERS)
            {
                var switches = message.getGraphiclayersmessage().getLayersList();
                console.log(switches);
                if (switches != null)
                {
                    context.commit('setSwitches', switches);
                }
            }
            else if (message.getMessagetype() == proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_OVERRIDE_SCOREBOARD)
            {
                var scoreboardOverrideMessage = message.getScoreboardoverridemessage();
                if (scoreboardOverrideMessage != null)
                {
                    var scoreboardProvider = scoreboardOverrideMessage.getScoreboardprovider();
                    var forceOverride = scoreboardOverrideMessage.getForceoverride();
                    console.log("Scoreboard Provider - " + scoreboardProvider);
                    console.log("Force Override - " + forceOverride);

                    context.commit('setForceOverride', forceOverride);
                    context.commit('setScoreboardProviderType', scoreboardProvider);
                }
            }
        },
        sendMessageAsCoordinatorMessage(context, payload) {
            var coordinatorMessage = new coordinator_messages.CoordinatorMessage();
            coordinatorMessage.setMessagetypestr(payload.msgType);
            coordinatorMessage.setMessagecontent(payload.msg.serializeBinary());
            context.commit({
                type: 'sendCoordinatorData', 
                data: coordinatorMessage
            });
        },
        logScoreboardState(context){
            context.commit("logState");
        },
        checkManualOverride(context){
            return new Promise(function(resolve, reject){
                var needsOverride = context.getters.getNeedsOverride;
                var answer = true;
                if(needsOverride)
                {
                    var answer = confirm("Current Scoreboard Provider is " + context.getters.getScoreboardProvider.text + " continuing will override to manual scoreboard \nAre you sure?");
                    if(answer)
                    {
                        var gm = createOverrideToWebMessage();
                        setTimeout(function() {
                            context.commit({
                                type: 'sendData', 
                                data: gm
                            });
                        }, 500);
                    }
                }
                resolve(answer);
            });
        }
    },
    mutations: {
        setClockDirection(state, direction) {
            state.clockDirection = direction;
        },
        setSwitches(state, switches) {
            var newSwitches = [];
            for (var i = 0; i < switches.length; i++)
            {   
                if (switches[i].getUpdateui())
                {
                    newSwitches.push({ id: switches[i].getId(), 
                        name: switches[i].getName(), 
                        value: switches[i].getValue(),
                        state: switches[i].getState(),
                        type: switches[i].getType() });
                }
            }
            if (newSwitches.length > 0)
            {
                state.controllerSwitches = [];
                state.controllerSwitches = newSwitches;
            }
            
            console.log("Switches");
            console.log(state.controllerSwitches);
        },
        logState(state){
            var msg = {};
            msg["homeScore"] = state.homeScore;
            msg["homeName"] = state.homeName;
            msg["awayScore"] = state.awayScore;
            msg["awayName"] = state.awayName;
            msg["connectedToWSProxy"] = state.connectedToWSProxy;
            msg["clockSeconds"] = state.clockSeconds;
            msg["clockMinutes"] = state.clockMinutes;
            msg["showPresets"] = state.showPresets;
            msg["clockStarted"] = state.clockStarted;
            notifyDataSent("LogScoreboardState", state.homeName + "_" + state.awayName, msg)
        },
        sendPong(state) {
            if (state.wsSocket.readyState === 1)
            {
                console.log("sending pong");
                state.wsSocket.send(JSON.stringify({ data: { type: 'pong', payload: {}}}));
            }
        },
        sendData(state, payload) {
            if (state.wsSocket.readyState === 1)
            {
                var buf = payload.data.serializeBinary();
                state.wsSocket.send(buf);
                notifyDataSent("SendData", state.homeName + "_" + state.awayName, payload)                               
            }
        },
        sendCoordinatorData(state, payload) {
            if (state.wsCoordinator.readyState === 1)
            {
                var buf = payload.data.serializeBinary();
                state.wsCoordinator.send(buf);      
                notifyDataSent("sendCoordinatorData", state.homeName + "_" + state.awayName, payload)                         
            }
        },
        setSingularURL(state, url) {
            state.singularURL = url;
        },
        sendScore(state) {
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_UPDATE);
            gm.setUpdatemessage(new proto_messages.ScoreboardUpdateMessage());
            gm.getUpdatemessage().setHometeamscore(state.homeScore);
            gm.getUpdatemessage().setAwayteamscore(state.awayScore);

            if (state.wsSocket.readyState === 1)
            {
                var buf = payload.data.serializeBinary();
                state.wsSocket.send(buf);                               
            }
        },
        setClockStarted(state, value) {
            state.clockStarted = value;
        },
        setHomeScore(state, value) {
            console.log("Sending home score");
            state.homeScore = value;
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_UPDATE);
            gm.setUpdatemessage(new proto_messages.ScoreboardUpdateMessage());
            gm.getUpdatemessage().setHometeamscore(value);
            gm.getUpdatemessage().setAwayteamscore(state.awayScore);
            if (state.wsSocket.readyState === 1)
            {
                var buf = gm.serializeBinary();
                state.wsSocket.send(buf);     
                notifyDataSent("setHomeScore", state.homeName + "_" + state.awayName, gm)                          
            }
        },
        setHomeName(state, value) {
            if (state.homeName == value)
                return;

            state.homeName = value;
            debounce(function (e) 
            {
                console.log("Sending home team name " + value);
                var gm = new proto_messages.GeneralMessage();
                gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_TEAMNAMES);
                gm.setTeamnamesmessage(new proto_messages.TeamNames());
                gm.getTeamnamesmessage().setHometeamname(state.homeName);
                gm.getTeamnamesmessage().setAwayteamname(state.awayName);
    
                if (state.wsSocket.readyState === 1)
                {
                    var buf = gm.serializeBinary();
                    state.wsSocket.send(buf);                               
                }
            }, 500)();
        },
        updateMessageReceived(state, value) {
            state.homeScore = value.getHometeamscore();
            state.awayScore = value.getAwayteamscore();state.firstConnection = false;
            eventBus.$emit('firstConnection', {HomeScore: state.homeScore , AwayScore: state.awayScore});  
        },
        setAwayScore(state, value) {
            state.awayScore = value;
            console.log("Sending away score");
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_UPDATE);
            gm.setUpdatemessage(new proto_messages.ScoreboardUpdateMessage());
            gm.getUpdatemessage().setHometeamscore(state.homeScore);
            gm.getUpdatemessage().setAwayteamscore(state.awayScore);
            if (state.wsSocket.readyState === 1)
            {
                var buf = gm.serializeBinary();
                state.wsSocket.send(buf);
                notifyDataSent("setAwayScore", state.homeName + "_" + state.awayName, gm)                               
            }
            
        },
        setAwayName(state, value)
        {
            if (state.awayName == value)
                return;
            
            state.awayName = value;
            debounce(function (e) 
            {
                console.log("Sending away team name " + value);            
                var gm = new proto_messages.GeneralMessage();
                gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_TEAMNAMES);
                gm.setTeamnamesmessage(new proto_messages.TeamNames());
                gm.getTeamnamesmessage().setHometeamname(state.homeName);
                gm.getTeamnamesmessage().setAwayteamname(state.awayName);

                if (state.wsSocket.readyState === 1)
                {
                    var buf = gm.serializeBinary();
                    state.wsSocket.send(buf);                               
                }
            }, 500)();
        },
        setSeconds(state, value) {
            state.clockSeconds = value;
        },
        setMinutes(state, value) {
            state.clockMinutes = value;
        },
        setSuspendTeamNamesUpdate(state, value) {
            state.suspendTeamNamesUpdate = value;
        },
        setSportsType(state, value) {
            state.currentSportsType = value;
        },
        setScoreboardProviderType(state, value) {
            state.scoreboardProviderType = state.scoreProviderTypes[value];
            console.log("Scoreboard Provider Type - " + state.scoreboardProviderType.text);
        },
        setForceOverride(state, value) {
            state.needsOverride = value;
        },
        setSelectedPeriod(state, value) {
            state.selectedPeriod = value;
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_UPDATE);
            gm.setUpdatemessage(new proto_messages.ScoreboardUpdateMessage());
            gm.getUpdatemessage().setHometeamscore(state.homeScore);
            gm.getUpdatemessage().setAwayteamscore(state.awayScore);
            gm.getUpdatemessage().setQuarter(state.selectedPeriod.toString());

            if (state.wsSocket.readyState === 1)
            {
                var buf = gm.serializeBinary();
                state.wsSocket.send(buf);                               
            }
        },
        setPeriodLength(state, value) {
            state.periodLength = value;
        },
        setExtraTime(state, value) {
            state.extraTime = value;
        },
        setOverTime(state, value) {
            state.overTime = value;
        },
        swapDirection(state) {
            state.clockDirection = (state.clockDirection == proto_messages.ClockDirection.CLOCK_DIRECTION_UP) ? 
            proto_messages.ClockDirection.CLOCK_DIRECTION_DOWN : proto_messages.ClockDirection.CLOCK_DIRECTION_UP;
        },
        setLayerState(state, value) {
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_GRAPHICS_LAYERS);
            gm.setGraphiclayersmessage(new proto_messages.GraphicLayers());


            for (var i = 0; i < state.controllerSwitches.length; i++)
            {        
                var layerId = state.controllerSwitches[i].id;
                var layerName = state.controllerSwitches[i].name;
                var layerValue = state.controllerSwitches[i].value;
                var layerState = (layerId == value.Id) ? value.State : state.controllerSwitches[i].state;
                var layerType = state.controllerSwitches[i].type;
                
                var layer = new proto_messages.GraphicLayer();
                layer.setId(layerId);
                layer.setState(layerState);
                layer.setName(layerName);
                layer.setValue(layerValue);
                layer.setType(layerType);
                
                gm.getGraphiclayersmessage().getLayersList().push(layer);        
            }
            if (state.wsSocket.readyState === 1)
            {
                console.log("Sending status " + value.State + " for layer id: " + value.Id);
                var buf = gm.serializeBinary();
                state.wsSocket.send(buf);                               
            }            
        },
        setCard(state, name) {
            var gm = new proto_messages.GeneralMessage();
            gm.setMessagetype(proto_messages.ScoreboardMessageType.SB_MESSAGE_TYPE_GRAPHICS_LAYERS);
            gm.setGraphiclayersmessage(new proto_messages.GraphicLayers());
            
            var layer = new proto_messages.GraphicLayer();
            layer.setId("-1");
            layer.setState(true);
            layer.setName(name);
            layer.setValue("");
            layer.setType(proto_messages.ControlType.BOOL);
            
            gm.getGraphiclayersmessage().getLayersList().push(layer);        
            if (state.wsSocket.readyState === 1)
            {
                console.log("Sending card " + name);
                var buf = gm.serializeBinary();
                state.wsSocket.send(buf);                               
            }
        },
        setConnectedToWSProxy(state, connection){
            state.connectedToWSProxy = connection;
        }
    },
    getters: {
        venueId(state) {
            return urlVenueId;
        },        
        homeScore(state) {
            return state.homeScore;
        },
        homeName(state) {
            return state.homeName;
        },
        awayScore(state) {
            return state.awayScore;
        },
        awayName(state) {
            return state.awayName;
        },
        getSeconds(state) {
            return state.clockSeconds;
        },
        getMinutes(state) {
            return state.clockMinutes;
        },
        getClockStarted(state) { 
            return state.clockStarted;
        },
        getSingularURL(state) {
            return state.singularURL;
        },
        getCurrentSportsType(state) {
            return state.currentSportsType;
        },
        getClockDirection(state) {
            return state.clockDirection;
        },
        getPeriodLength(state) {
            return state.periodLength;
        },
        getExtraTime(state) {
            return state.extraTime;
        },
        getSelectedPeriod(state) {
            return state.selectedPeriod;
        },
        getOverTime(state) {
            return state.overTime;
        },
        getShowLayers(state) {
            return state.showLayers;
        },
        getControllerSwitches(state) {
            return state.controllerSwitches;
        }, 
        getShowPresets(state) {
            return state.showPresets;
        },
        getNeedsOverride(state) {
            return state.needsOverride;
        },
        getScoreboardProvider(state) {
            return state.scoreboardProviderType;
        }
    }    
});


// WEBPACK FOOTER //
// ./src/store.js